import { render, staticRenderFns } from "./PayRangeHeader.vue?vue&type=template&id=1db341c6&scoped=true"
import script from "./PayRangeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeHeader.vue?vue&type=style&index=0&id=1db341c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db341c6",
  null
  
)

export default component.exports